// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2d73b780]:export {\n  sideBarWidth: 210px;\n  appHeaderHeight: 60px;\n  interval: 16px;\n}\n.table-container .active[data-v-2d73b780] {\n  color: #3870ff;\n  cursor: pointer;\n}\n.table-container[data-v-2d73b780] .ant-table-column-title {\n  font-family: PingFangSC-Medium;\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.85);\n}\n", ""]);
// Exports
module.exports = exports;
